// 历史路由只解释当时存储的JSON，不通过当前配置补名称或匹配结果（D125）。
/** JSON对象判断用于兼容缺失、旧记录和未知格式。 */
export function isTraceObject(value: unknown): value is Record<string, unknown> { return value !== null && typeof value === "object" && !Array.isArray(value); }

/** 同时读取现行RoutingOutput包装与早期直接保存的RoutingTrace。 */
export function storedRoutingTrace(value: unknown): Record<string, unknown> | null {
  if (!isTraceObject(value)) return null;
  if ("trace" in value) return isTraceObject(value.trace) ? value.trace : null;
  return ["account_routing", "route_id", "matched_rule_ids", "retry_group_id", "retry_channel_id", "fallback", "excluded", "group_path"].some(k => k in value) ? value : null;
}

/** 零也是合法优先级/文件配置版本，不把缺失或字符串转换成零。 */
export function traceNumber(value: unknown): string { return typeof value !== "number" || !Number.isInteger(value) ? "—" : Number.isSafeInteger(value) ? String(value) : "超出安全整数范围"; }

// 后端原因码集中在 internal/policy/trace_reason.go，Go 测试逐个核对这里都有中文名，后端新增而此处漏登记即失败（#406）。
const traceReasonNames: Record<string, string> = {
  matched: "已命中目标", account_no_match: "账号没有启用且匹配的绑定", template_disabled: "模板已停用", template_no_match: "模板没有匹配的规则",
  target_unavailable: "命中目标没有可用通道", profit_guard: "利润保护已熔断",
  validity_unsupported: "不支持指定有效期", channel_disabled: "通道停用", channel_removed: "通道已摘除", not_pinned: "不是账号钉死的通道", unicode_unsupported: "不支持Unicode",
  length_exceeded: "超过通道长度限制", sender_unsupported: "不支持该Sender", already_tried: "已经尝试过", circuit_open: "熔断中", circuit_half_open: "处于半开期", tps_limited: "慢启动TPS已用完", no_cost_price: "没有生效的成本价或汇率",
  circuit_probe: "半开试探", test_send: "按通道发送测试",
  primary_backup_active: "主备：发给当前通道", primary_backup_probe: "主备：小流量", primary_backup_verify: "主备：验证中的通道",
  primary_backup_active_unavailable: "主备：当前通道不可用，按优先级",
};

/** 新增未知原因原样显示，历史记录不因前端版本旧而丢失线索。 */
export function traceReason(value: unknown): string {
  if (typeof value !== "string" || !value) return "—";
  const name = Object.hasOwn(traceReasonNames, value) ? traceReasonNames[value] : undefined;
  return name ? `${name}（${value}）` : value;
}

/** 有身份才显示版本，直接目标不伪造模板或旧方案。 */
export function traceIdentity(id: unknown, version?: unknown): string {
  if (typeof id !== "number" || !Number.isSafeInteger(id) || id <= 0) return "—";
  const number = String(id);
  return version === undefined ? `#${number}` : `#${number} · v${traceNumber(version)}`;
}

/** 只接受记录中的数值ID数组，保持顺序；异常内容仍可在原始JSON中查看。 */
export function traceIDs(value: unknown): string {
  return Array.isArray(value) ? value.map(id => traceIdentity(id)).filter(id => id !== "—").join(" → ") || "—" : "—";
}
